import { getColorWithAlpha } from '@elfsight/lib-utils';

export const COMPONENT_NAME = 'checkout-component-layout';
export const BACKDROP_COLOR = getColorWithAlpha('#111', 0.7);
